import { animate, state, style, transition, trigger, AnimationEvent } from '@angular/animations';
import { Directive, HostBinding, HostListener, Input } from '@angular/core';
import { IAnimationWithCallbacks } from './interfaces/ianimation-with-callbacks.interface';

export const DisplayFadeInOutAnimation: IAnimationWithCallbacks = {
	animation: [
		trigger('displayFadeInOut', [
			state('active', style({ opacity: 1 })),
			state('inactive', style({ opacity: 0 })),
			transition('active => inactive', animate('0.5s')),
			transition('inactive => active', animate('0.5s'))
		])
	],
	start(event: AnimationEvent): void {
		const stateMap: Record<string, string> = {
			void: 'none',
			inactive: 'block'
		};

		(<HTMLElement>event.element).style.display = stateMap[event.fromState];
	},
	done(event: AnimationEvent): void {
		const stateMap: Record<string, string> = {
			active: 'block',
			inactive: 'none',
			void: 'none'
		};

		(<HTMLElement>event.element).style.display = stateMap[event.toState];
	}
};

@Directive({
	// eslint-disable-next-line @angular-eslint/directive-selector
	selector: '[displayFadeInOutAnimation]',
	standalone: true
})
export class NHADisplayFadeInOutAnimationDirective {
	@Input('displayFadeInOutAnimation') selector: string;

	@HostBinding('@displayFadeInOut') get animation(): string {
		return this.selector;
	}

	@HostListener('@displayFadeInOut.start', ['$event'])
	animationStart(event: AnimationEvent): void {
		DisplayFadeInOutAnimation.start(event);
	}

	@HostListener('@displayFadeInOut.done', ['$event'])
	animationDone(event: AnimationEvent): void {
		DisplayFadeInOutAnimation.done(event);
	}
}
